import { IconButton, Tooltip } from '@mui/material';
import { Download } from '@mui/icons-material';
import useTranslation from 'Hooks/useTranslation';
import GenericTableText from 'Components/GenericTableText/GenericTableText';
import React from 'react';

interface CertificateDownloadProps {
  certificationId: string | null;
  onDownload?: () => void;
}

const CertificateDownload = ({ certificationId, onDownload }: CertificateDownloadProps) => {
  const { t2 } = useTranslation('employees_courses_report');

  if (!certificationId) {
    return <GenericTableText text={t2('unavailable')} tooltip={t2('no_certificate_tooltip')} />;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDownload?.();
  };

  return (
    <Tooltip title={t2('download_certificate')}>
      <IconButton onClick={handleClick} aria-label={t2('download_certificate')}>
        <Download />
      </IconButton>
    </Tooltip>
  );
};

export default CertificateDownload;
